import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Logo4 from '../assets/images/bonhomme-folks.svg';
import Tache1 from '../assets/images/tache1.svg';
import Tache2 from '../assets/images/tache2.svg';
import Tache3 from '../assets/images/tache3.svg';

interface LogoIntroProps {
  onComplete: () => void;
}

const LogoIntro: React.FC<LogoIntroProps> = ({ onComplete }) => {
  const [logos, setLogos] = useState<Array<{ id: number; x: number; y: number; scaleX: number; scale: number }>>([]);
  const [startExit, setStartExit] = useState(false);

  useEffect(() => {
    // Générer des logos pour remplir l'écran
    const logoCount = 200;
    const generatedLogos = Array.from({ length: logoCount }, (_, i) => ({
      id: i,
      x: Math.random() * (window.innerWidth + 200) - 100,
      y: Math.random() * (window.innerHeight + 200) - 100,
      scaleX: Math.random() > 0.5 ? 1 : -1,
      scale: 1.0 + Math.random() * 0.5,
    }));
    setLogos(generatedLogos);

    // Déclencher la dispersion après 1 seconde
    setTimeout(() => {
      setStartExit(true);
      // Attendre que l'animation soit terminée avant d'appeler onComplete
      setTimeout(() => {
        onComplete();
      }, 800);
    }, 1500);
  }, [onComplete]);

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 10000,
        overflow: 'hidden',
        pointerEvents: 'none',
      }}
    >
      {/* Taches grunge en arrière-plan */}
      {Array.from({ length: 20 }, (_, i) => {
        const taches = [Tache1, Tache2, Tache3];
        const randomTache = taches[Math.floor(Math.random() * taches.length)];
        return (
          <img
            key={`tache-${i}`}
            src={randomTache}
            alt=""
            style={{
              position: 'absolute',
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              width: `${30 + Math.random() * 30}px`,
              transform: `rotate(${Math.random() * 360}deg)`,
              opacity: 0.6,
            }}
          />
        );
      })}

      <AnimatePresence>
        {!startExit && logos.map((logo) => {
          const exitX = logo.x < window.innerWidth / 2 ? -500 : window.innerWidth + 500;
          const exitY = logo.y < window.innerHeight / 2 ? -500 : window.innerHeight + 500;

          return (
            <motion.img
              key={logo.id}
              src={Logo4}
              alt=""
              initial={{
                x: logo.x,
                y: logo.y,
                scale: logo.scale,
                scaleX: logo.scaleX,
              }}
              exit={{
                x: exitX,
                y: exitY,
                scale: 0,
                scaleX: logo.scaleX,
                transition: { duration: 0.6, delay: logo.id * 0.001 },
              }}
              style={{
                position: 'absolute',
                width: '150px',
                height: '150px',
              }}
            />
          );
        })}
      </AnimatePresence>
    </div>
  );
};

export default LogoIntro;
